import React, { Component, useState, useEffect } from 'react';
import './hud.css';




export default class Hud extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="hud">
                <div id="score">
                    <p>Score : {this.props.score} </p>
                    <p>Vie : {this.props.vie}</p>
                </div>
            </div>
        );
    }

}